import React from "react";
import "./styles.css";
// Dữ liệu mẫu (mô phỏng 500 đánh giá)
const testimonialData = {
  averageRating: 4.7,
  totalReviews: 500,
  ratingDistribution: {
    5: 380, // 76%
    4: 80, // 16%
    3: 20, // 4%
    2: 10, // 2%
    1: 10, // 2%
  },
  reviews: [
    {
      name: "Anh Minh (Tập đoàn X)",
      date: "12/2024",
      text: "Habako M&E thi công hệ thống điều hòa trung tâm rất chuyên nghiệp. Tiến độ nhanh, chất lượng vượt mong đợi.",
      rating: 5,
    },
    {
      name: "Chị Hoa (Chủ đầu tư)",
      date: "11/2024",
      text: "Đội ngũ kỹ thuật hàn cơ khí và lắp đặt điện nước rất bài bản, ít xảy ra sự cố. Rất đáng tin cậy.",
      rating: 5,
    },
    {
      name: "Công ty Z",
      date: "10/2024",
      text: "Giá cả cạnh tranh, tư vấn nhiệt tình. Tuy nhiên, thời gian bảo hành hơi chậm một chút.",
      rating: 4,
    },
  ],
};

// Component thanh tiến trình sao
const RatingBar = ({ stars, count, total }) => {
  const percentage = (count / total) * 100;
  return (
    <div className="rating-bar">
      <span className="star-label">{stars} Sao</span>
      <div className="bar-container">
        <div className="bar-fill" style={{ width: `${percentage}%` }}></div>
      </div>
      <span className="count-label">{count}</span>
    </div>
  );
};

// Component Star Rating đơn giản
const ReviewStars = ({ rating }) => {
  return (
    <div className="review-stars">
      {[...Array(5)].map((_, i) => (
        <span
          key={i}
          className="star"
          style={{ color: i < rating ? "#ffc107" : "#ccc" }}
        >
          ★
        </span>
      ))}
    </div>
  );
};

const TestimonialsSection = () => {
  const { averageRating, totalReviews, ratingDistribution, reviews } =
    testimonialData;
  const distributionKeys = [5, 4, 3, 2, 1];

  return (
    <section className="testimonials-section">
      <h3 className="testimonials__subtitle">
        Ý KIẾN KHÁCH HÀNG VÀ ĐÁNH GIÁ DỰ ÁN
      </h3>

      <div className="testimonials__content-wrapper">
        {}
        <div className="testimonials__summary">
          <p className="summary__title">Đánh giá trung bình</p>
          <div className="summary__rating-block">
            <span className="summary__score">{averageRating.toFixed(1)}</span>
            <div className="summary__stars">
              <ReviewStars rating={Math.round(averageRating)} />
              <p className="summary__review-count">({totalReviews} đánh giá)</p>
            </div>
          </div>

          {}
          <div className="summary__distribution">
            {distributionKeys.map((stars) => (
              <RatingBar
                key={stars}
                stars={stars}
                count={ratingDistribution[stars]}
                total={totalReviews}
              />
            ))}
          </div>
        </div>

        {}
        <div className="testimonials__reviews">
          {reviews.map((review, index) => (
            <div key={index} className="review__card">
              <div className="review__header">
                <ReviewStars rating={review.rating} />
                <span className="review__date">{review.date}</span>
              </div>
              <p className="review__author">{review.name}</p>
              <p className="review__text">"{review.text}"</p>
            </div>
          ))}
          <button className="reviews__view-more-btn">
            XEM TẤT CẢ PHẢN HỒI
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
